const makeRgbBg = rgbArr => {
    return `rgb(${rgbArr.toString()})`
}

export { makeRgbBg };


// WEBPACK FOOTER //
// ./src/utilis/makeRgbBg.js